import React from 'react';
import { Grid, Box } from '@mui/material';
import {
    Select,
    Input,
} from '../../Common';
import { yes_no_options } from '../utils';
import { TranslateW } from "../../../Utils/Languages/Translate";
const isNestedProperty = true;

const ProblemResolution = ({
    formState,
    setGlobalState,
    dropdownOptions,
    requiredFieldsMissing,
    oldRequiredFields,
    setRequiredFields,
    requiredFieldsRef,
}) => {
    const setConditionalRequiredFields = () => {
        const newRequiredFields = {
            ...oldRequiredFields,
            "ProblemResolution": [
                "remainingProblemDetails"
            ]
        };
        requiredFieldsRef.current = newRequiredFields;
        setRequiredFields(newRequiredFields);
    };

    const clearConditionalRequiredFields = () => {
        const newRequiredFields = { ...oldRequiredFields, "ProblemResolution": [] };
        requiredFieldsRef.current = newRequiredFields;
        setRequiredFields(newRequiredFields);
    };

    const handleWasProblemResolved = (wasProblemResolved) => {
        delete formState.maintenanceNoGas.remainingProblemDetails;
        clearConditionalRequiredFields();
        setGlobalState("maintenanceNoGas.wasProblemResolved", wasProblemResolved, isNestedProperty);

        if (!wasProblemResolved) {
            setConditionalRequiredFields();
        }
    };

    return (
        <Grid container spacing={4} justifyContent='center'>
            <Grid item xs={6} md={6} lg={6}>
                <Select
                    label={TranslateW("ServiceEventRepairDetails.StatusAfterService")}
                    value={formState.maintenanceNoGas.workCompletedAssetStatusID}
                    onChange={e => setGlobalState("maintenanceNoGas.workCompletedAssetStatusID", e.target.value, isNestedProperty)}
                    options={dropdownOptions.afterServiceStatusOptions}
                />
                <Box mt={4} />
                <Select
                    label={TranslateW("ServiceEventStepProblemResolution.WasProblemResolved")}
                    value={formState.maintenanceNoGas.wasProblemResolved}
                    onChange={e => handleWasProblemResolved(e.target.value)}
                    options={yes_no_options}
                />
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
                <Input
                    fullWidth
                    required
                    multiLine
                    rows={5}
                    disabled={[undefined, true].includes(formState.maintenanceNoGas.wasProblemResolved)}
                    label={TranslateW('ServiceEventStepProblemResolution.DescribeRemainingProblem')}
                    value={formState.maintenanceNoGas.remainingProblemDetails || ''}
                    onChange={e => setGlobalState("maintenanceNoGas.remainingProblemDetails", e.target.value, isNestedProperty)}
                    error={requiredFieldsMissing.maintenanceNoGas.remainingProblemDetails}
                />
            </Grid>
        </Grid>
    );
};

export default ProblemResolution;
